import assignTestFileReducer from './testFileReducer';
import assignStudentDataReducer from './studentDataReducer';
import assignCourseInstanceReducer from './courseInstanceReducer';
import assignAssignmentReducer from './assignmentReducer';

export default {
  assignTestFileReducer,
  assignStudentDataReducer,
  assignCourseInstanceReducer,
  assignAssignmentReducer,
}
